document.addEventListener('DOMContentLoaded', function(){
  document.querySelectorAll('[data-mobile-toggle]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var menu = document.querySelector('[data-mobile-menu]');
      if(menu){ menu.classList.toggle('open'); }
    });
  });
});


/* v94 Ajax cart drawer */
(function(){
  function formatMoney(cents){
    var amount = (Number(cents || 0) / 100);
    return '$' + amount.toFixed(2);
  }

  function cartDrawerShell(){ return document.querySelector('[data-cart-drawer-shell]'); }
  function cartDrawer(){ return document.querySelector('[data-cart-drawer]'); }

  function openCartDrawer(){
    var shell = cartDrawerShell();
    var drawer = cartDrawer();
    if(!shell || !drawer) return;
    shell.hidden = false;
    requestAnimationFrame(function(){
      shell.classList.add('is-open');
      drawer.setAttribute('aria-hidden','false');
      document.documentElement.classList.add('td-cart-open');
    });
  }

  function closeCartDrawer(){
    var shell = cartDrawerShell();
    var drawer = cartDrawer();
    if(!shell || !drawer) return;
    shell.classList.remove('is-open');
    drawer.setAttribute('aria-hidden','true');
    document.documentElement.classList.remove('td-cart-open');
    setTimeout(function(){ if(!shell.classList.contains('is-open')) shell.hidden = true; }, 220);
  }

  function productImage(item){
    return item.image || (item.featured_image && item.featured_image.url) || '';
  }

  function renderCart(cart){
    var body = document.querySelector('[data-cart-drawer-body]');
    var footer = document.querySelector('[data-cart-drawer-footer]');
    var countEls = document.querySelectorAll('[data-cart-drawer-count]');
    countEls.forEach(function(el){ el.textContent = cart.item_count; });

    // Update visible header cart count, including the static header "Cart 0" text pattern.
    document.querySelectorAll('.td-static-actions a[href="/cart"], .td-static-actions a[href*="/cart"]').forEach(function(link){
      var svg = link.querySelector('svg');
      if(svg){
        Array.from(link.childNodes).forEach(function(node){
          if(node.nodeType === 3) node.nodeValue = ' ' + cart.item_count;
        });
      }
    });

    if(!body || !footer) return;

    if(!cart.items || !cart.items.length){
      body.innerHTML = '<div class="td-cart-drawer__empty"><p>Your cart is empty.</p><a class="td-button" href="/collections/all">Shop Programs</a></div>';
      footer.innerHTML = '';
      return;
    }

    body.innerHTML = cart.items.map(function(item){
      var img = productImage(item);
      var variant = item.variant_title && item.variant_title !== 'Default Title'
        ? '<p class="td-cart-drawer__variant">'+item.variant_title+'</p>'
        : '';
      return '<div class="td-cart-drawer__item">'
        + '<a class="td-cart-drawer__image" href="'+item.url+'">'+(img ? '<img src="'+img+'" alt="'+item.product_title+'">' : '')+'</a>'
        + '<div class="td-cart-drawer__item-main">'
        + '<div class="td-cart-drawer__item-top"><a class="td-cart-drawer__title" href="'+item.url+'">'+item.product_title+'</a><button type="button" class="td-cart-drawer__remove" data-cart-remove="'+item.key+'" aria-label="Remove '+item.product_title+'">×</button></div>'
        + variant
        + '<div class="td-cart-drawer__item-bottom"><div class="td-cart-drawer__qty"><button type="button" data-cart-change="'+item.key+'" data-cart-qty="'+(item.quantity-1)+'">−</button><span>'+item.quantity+'</span><button type="button" data-cart-change="'+item.key+'" data-cart-qty="'+(item.quantity+1)+'">+</button></div><span class="td-cart-drawer__price">'+formatMoney(item.final_line_price)+'</span></div>'
        + '</div></div>';
    }).join('');

    footer.innerHTML = '<div class="td-cart-drawer__subtotal"><span>Subtotal:</span><strong>'+formatMoney(cart.total_price)+'</strong></div>'
      + '<p>Taxes and discounts calculated at checkout.</p>'
      + '<div class="td-cart-drawer__actions"><a class="td-button secondary" href="/cart">View Shopping Bag</a><a class="td-button" href="/checkout">Checkout</a></div>';
  }

  function refreshCart(open){
    return fetch('/cart.js', {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(cart){ renderCart(cart); if(open) openCartDrawer(); return cart; });
  }

  document.addEventListener('click', function(e){
    if(e.target.closest('[data-cart-drawer-close]')){
      e.preventDefault();
      closeCartDrawer();
      return;
    }

    var cartLink = e.target.closest('a[href="/cart"], a[href*="/cart"]');
    if(cartLink && !cartLink.closest('.td-cart-drawer') && !cartLink.closest('.td-cart-drawer__footer')){
      e.preventDefault();
      refreshCart(true);
      return;
    }

    var removeBtn = e.target.closest('[data-cart-remove]');
    if(removeBtn){
      e.preventDefault();
      fetch('/cart/change.js', {
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({id:removeBtn.getAttribute('data-cart-remove'), quantity:0})
      }).then(function(){ return refreshCart(true); });
      return;
    }

    var changeBtn = e.target.closest('[data-cart-change]');
    if(changeBtn){
      e.preventDefault();
      var qty = Math.max(0, parseInt(changeBtn.getAttribute('data-cart-qty'),10) || 0);
      fetch('/cart/change.js', {
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({id:changeBtn.getAttribute('data-cart-change'), quantity:qty})
      }).then(function(){ return refreshCart(true); });
    }
  });

  document.addEventListener('submit', function(e){
    var form = e.target;
    if(!form || !form.matches('form[action*="/cart/add"]')) return;

    e.preventDefault();

    var submitButton = form.querySelector('[type="submit"]');
    var originalText = submitButton ? submitButton.textContent : '';
    if(submitButton){
      submitButton.disabled = true;
      submitButton.textContent = 'Adding...';
    }

    fetch('/cart/add.js', {
      method:'POST',
      headers:{'Accept':'application/json'},
      body:new FormData(form)
    })
    .then(function(response){
      if(!response.ok) throw new Error('Could not add to cart');
      return response.json();
    })
    .then(function(){
      return refreshCart(true);
    })
    .catch(function(){
      form.submit();
    })
    .finally(function(){
      if(submitButton){
        submitButton.disabled = false;
        submitButton.textContent = originalText;
      }
    });
  });

  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape') closeCartDrawer();
  });
})();


/* v95 product page image gallery */
(function(){
  document.addEventListener('click', function(event){
    var thumb = event.target.closest('[data-product-thumb]');
    if(!thumb) return;

    var gallery = thumb.closest('[data-product-gallery]');
    if(!gallery) return;

    var mainImage = gallery.querySelector('[data-product-main-image]');
    var fullImage = thumb.getAttribute('data-full-image');
    var alt = thumb.getAttribute('data-alt') || '';

    if(mainImage && fullImage){
      mainImage.setAttribute('src', fullImage);
      mainImage.setAttribute('srcset', '');
      mainImage.setAttribute('alt', alt);
    }

    gallery.querySelectorAll('[data-product-thumb]').forEach(function(button){
      button.classList.toggle('is-active', button === thumb);
    });
  });
})();


/* v96 product page image lightbox */
(function(){
  var activeGallery = null;
  var activeImages = [];
  var activeIndex = 0;

  function lightbox(){ return document.querySelector('[data-product-lightbox]'); }
  function lightboxImage(){ return document.querySelector('[data-product-lightbox-image]'); }

  function getGalleryImages(gallery){
    return Array.prototype.map.call(gallery.querySelectorAll('[data-lightbox-image]'), function(el){
      return {
        src: el.getAttribute('data-full-image') || '',
        alt: el.getAttribute('data-alt') || ''
      };
    }).filter(function(item){ return item.src; });
  }

  function currentMainIndex(gallery){
    var main = gallery.querySelector('[data-product-main-image]');
    if(!main) return 0;
    var src = main.getAttribute('src') || '';
    var idx = activeImages.findIndex(function(item){ return src && item.src.indexOf(src.split('?')[0]) !== -1; });
    if(idx >= 0) return idx;

    var activeThumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-product-thumb]'));
    var activeThumb = activeThumbs.find(function(button){ return button.classList.contains('is-active'); });
    return activeThumb ? activeThumbs.indexOf(activeThumb) : 0;
  }

  function renderLightbox(){
    var lb = lightbox();
    var img = lightboxImage();
    if(!lb || !img || !activeImages.length) return;
    var item = activeImages[activeIndex] || activeImages[0];
    img.src = item.src;
    img.alt = item.alt || 'Product image';
  }

  function openLightbox(gallery){
    var lb = lightbox();
    if(!lb || !gallery) return;
    activeGallery = gallery;
    activeImages = getGalleryImages(gallery);
    if(!activeImages.length) return;
    activeIndex = currentMainIndex(gallery);
    lb.hidden = false;
    document.documentElement.classList.add('td-product-lightbox-open');
    renderLightbox();
  }

  function closeLightbox(){
    var lb = lightbox();
    if(!lb) return;
    lb.hidden = true;
    document.documentElement.classList.remove('td-product-lightbox-open');
  }

  function moveLightbox(delta){
    if(!activeImages.length) return;
    activeIndex = (activeIndex + delta + activeImages.length) % activeImages.length;
    renderLightbox();
  }

  document.addEventListener('click', function(event){
    var openButton = event.target.closest('[data-product-lightbox-open]');
    if(openButton){
      event.preventDefault();
      openLightbox(openButton.closest('[data-product-gallery]'));
      return;
    }

    if(event.target.closest('[data-product-lightbox-close]')){
      event.preventDefault();
      closeLightbox();
      return;
    }

    if(event.target.closest('[data-product-lightbox-prev]')){
      event.preventDefault();
      moveLightbox(-1);
      return;
    }

    if(event.target.closest('[data-product-lightbox-next]')){
      event.preventDefault();
      moveLightbox(1);
      return;
    }

    var lb = lightbox();
    if(lb && !lb.hidden && event.target === lb){
      closeLightbox();
    }
  });

  document.addEventListener('keydown', function(event){
    var lb = lightbox();
    if(!lb || lb.hidden) return;
    if(event.key === 'Escape') closeLightbox();
    if(event.key === 'ArrowLeft') moveLightbox(-1);
    if(event.key === 'ArrowRight') moveLightbox(1);
  });
})();


/* v102 mobile static header menu */
(function(){
  document.addEventListener('click', function(event){
    var toggle = event.target.closest('[data-static-mobile-toggle]');
    if(!toggle) return;

    var menu = document.querySelector('[data-static-mobile-menu]');
    if(!menu) return;

    var isOpen = menu.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    toggle.textContent = isOpen ? 'Close' : 'Menu';
  });

  document.addEventListener('click', function(event){
    var menu = document.querySelector('[data-static-mobile-menu]');
    var toggle = document.querySelector('[data-static-mobile-toggle]');
    if(!menu || !toggle || !menu.classList.contains('is-open')) return;

    if(event.target.closest('[data-static-mobile-menu]') || event.target.closest('[data-static-mobile-toggle]')) return;

    menu.classList.remove('is-open');
    toggle.setAttribute('aria-expanded','false');
    toggle.textContent = 'Menu';
  });
})();
